import SentenceStudyAssemblyBase from 'es6/controllers/apps/quizzes/sentence-study-assembly-base';

export class SentenceStudyListeningAssembly extends SentenceStudyAssemblyBase {
  constructor(...args) {
    super(...args);
    this._mode = 'listening';
    this._setQuizType('SentenceStudyListeningAssembly');
  }
}

export default SentenceStudyListeningAssembly;
